<pr-status-label
  [label]="status"
  [color]="statusColourMap[status]"
  [dense]="dense"
/>
